export enum SingleSetPromotionStates {
    INIT = 'INIT',
    BASIC = 'BASIC',
    START = 'START',
    IN_PROGRESS = 'IN_PROGRESS',
    DISABLED = 'DISABLED'
}
